// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s0WEQJg6KIqq5pusfzqj{margin-bottom:20px}.kEbO9nesuLI3PejA8Gg8{color:var(--content-primary-primary);margin-left:4px;font-size:13px;font-weight:400}.uSykhmbCwcdBjumHXEgK{color:var(--content-primary-tertiary);padding:8px;font-size:12px;font-weight:500}.RriexhIBbIGqqjeqBYK0{overflow:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allContacts": `s0WEQJg6KIqq5pusfzqj`,
	"segmentText": `kEbO9nesuLI3PejA8Gg8`,
	"segmentsHeader": `uSykhmbCwcdBjumHXEgK`,
	"folders": `RriexhIBbIGqqjeqBYK0`
};
export default ___CSS_LOADER_EXPORT___;
